var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sales-chart"},[_c('div',{staticClass:"chart-container"},[_c('h3',[_vm._v("플랫폼별 매출 비교")]),_c('bar-chart',{attrs:{"chart-data":_vm.barChartData,"options":_vm.barChartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }